import { Schedule } from '@/components/Domains/Schedule/Schedule'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const SearchSchema = z.object({
  selectedMonth: z.string().optional(),
})

export const Route = createFileRoute('/_auth/schedule')({
  component: Schedule,
  validateSearch: SearchSchema.parse,
})
